<template>
  <div>
    <Teleport v-if="model" to="body">
      <div class="modal__overlay z-10 fixed top-0 start-0 w-screen h-screen bg-black/40"></div>
      <div
        class="modal__wrapper z-50 fixed top-0 start-0 w-screen h-screen flex justify-center items-center"
      >
        <div
          :class="containerClass"
          class="modal__container bg-white shadow-lg rounded-md flex flex-col"
        >
          <slot name="container">
            <slot name="header">
              <div
                class="container__header border-b border-brand-gray-300 px-3 pt-2 pb-1 flex justify-between"
              >
                <HeaderTypo class="text-xl">{{ title }}</HeaderTypo>
                <slot name="closeIcon">
                  <button v-show="isShowClose" @click="onClose"><faTimes class="w-4" /></button>
                </slot>
              </div>
            </slot>
            <slot name="body">
              <div class="flex-1 container__body px-3 pt-2 pb-1 text-sm text-gray-600">
                <slot name="bodyContent"></slot>
              </div>
            </slot>
            <slot name="footer">
              <div class="container__footer px-3 pt-2 pb-1 border-t border-brand-gray-300">
                <slot name="footerContent"></slot>
              </div>
            </slot>
          </slot>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import faTimes from '@/assets/icons/faTimes.svg?component'
import { watch } from 'vue'

const model = defineModel()
defineProps({
  title: String,
  containerClass: {
    type: String,
    default: () => 'w-4/12'
  },
  isShowClose: {
    type: Boolean,
    default: true
  }
})

watch(model, (newValue) => {
  // Comment this line because if step one info is long, the page will CAN'T scrollable
  // document.body.style.overflow = newValue ? 'hidden' : 'inherit'
})

const onClose = () => {
  model.value = false
}
</script>

<script>
export default {
  name: 'ModalVue'
}
</script>

<style lang="scss" scoped></style>
